import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import HelpButton from '../../../../components/HelpButton';
import PbxVirtualOperator from './PbxVirtualOperator';
import TicketsFieldsTree from '../../Tickets/TicketsFieldsTree';
import { TicketEnums } from '../../../../js/tickets/TicketUtils';
import { getVirtualOperatorWhatsappNumber } from '../../../../js/me/selectors';
import ToastMessage from '../../../../components/messages/ToastMessage';

const messages = defineMessages({
  missingNumber: {
    id: 'PbxVirtualOperatorWhatsappQuestionsPage.missingNumber',
    defaultMessage: 'Whatsapp part of the Virtual Operator is not yet configured',
  }
});

const PbxVirtualOperatorWhatsappQuestionsPage = (props) => (
  <PbxVirtualOperator scrolling>
    <div className="text-right">
      <HelpButton fileName="virtual-operator-whatsapp-questions" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        {!props.hasWhatsappNumber && (
          <ToastMessage
            type="danger"
            text={props.intl.formatMessage(messages.missingNumber)}
            disableAutoClose
          />
        )}
        {/* Lazy load TicketsFieldsTree to avoid loading it if not needed */}
        <TicketsFieldsTree scope={TicketEnums.TicketScope.WHATSAPP} {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxVirtualOperator>
);

function mapStateToProps(state) {
  return {
    hasWhatsappNumber: !!getVirtualOperatorWhatsappNumber(state),
  };
}

export default injectIntl(
  connect(mapStateToProps)(PbxVirtualOperatorWhatsappQuestionsPage)
);
